import { getAssignLicenseEndpoint, removeLicense as getRemoveLicenseEndpoint, changeLicenseType as getSwitchLicenseEndpoint } from "../configuration";
import axiosInstance from "../global/axiosInterceptor";

export const assignLicense = async ({ accountname, deviceid, sku } = {}, activeSession = {}) => {
  try {
    const url = getAssignLicenseEndpoint();
    const body = {
      accountname: accountname || activeSession?.accountId || "",
      deviceidentifier: {
        deviceid: deviceid || ""
      },
      sku: sku || ""
    };

    const resp = await axiosInstance.post(url, body);
    return resp?.data;
  } catch (err) {
    throw err;
  }
};

export const switchLicense = async ({ accountname, deviceid, assignSku, removeSku } = {}) => {
  try {
    const url = getSwitchLicenseEndpoint();
    const body = {
      accountname: accountname || "",
      deviceidentifier: { deviceid: deviceid || "" },
      assignsku: assignSku || "",
      removesku: removeSku || ""
    };
    const resp = await axiosInstance.post(url, body);
    return resp?.data;
  } catch (err) {
    throw err;
  }
};

export const removeLicenseForFov = async ({ accountname, deviceid, sku } = {}) => {
  try {
    const url = getRemoveLicenseEndpoint();
    const body = {
      accountname: accountname || "",
      deviceidentifier: {
        deviceid: deviceid || ""
      },
      sku: sku || ""
    };
    const resp = await axiosInstance.post(url, body);
    return resp?.data;
  } catch (err) {
    throw err;
  }
};